module.exports = __webpack_public_path__ + "static/media/DO.c9240549.svg";